import * as React from 'react';

import { ERoomsTotal } from '../../../types/jsonQuery';
import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { FlatRooms } from '../../../components/advancedFilters/FlatRooms';

export const FlatRoomsContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  let rooms = getTermsValue('rooms_count')(jsonQuery);
  if (rooms && rooms.length === 0) {
    rooms = null;
  }

  const handleChange = React.useCallback(
    (value: NonEmptyArray<ERoomsTotal> | null) => {
      onChange({ action: 'setRoomsCount', arguments: [value] });
    },
    [onChange],
  );

  return <FlatRooms value={rooms as NonEmptyArray<ERoomsTotal> | null} onChange={handleChange} />;
};
